import { Stack } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { GridColDef } from "@mui/x-data-grid";
import React, { useState } from "react";
import ButtonBar from "../../../components/Buttons/ButtonBar";
import NewButton from "../../../components/Buttons/NewButton";
import SearchButton from "../../../components/Buttons/SearchButton";
import UploadButton from "../../../components/Buttons/UploadButton";
import CommonPagination from "../../../components/CustomPagination/CommonPagination";
import CommonTable from "../../../components/CustomTable/CommonTable";
import ProgressIndicator from "../../../components/ProgressIndicator";
import BasicMenu from "../../../components/menu/BasicMenu";
import strings from "../../../config/localization";
import { useGetExternalForcesQuery } from "../../../services/appln";
import { getBaseURL, getRowsPerPage } from "../../constants";
import { doesPermissionExist } from "../../util";
import DeleteExternalForce from "./DeleteExternalForce";
import EditPersonnel from "./EditPersonnel";
import NewExternalForce from "./NewExternalForce";
import UploadExternalForces from "./UploadExternalForces";

export default function ListExternalForces(props: any) {
  const [pageNo, setPageNo] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(getRowsPerPage());

  const [searchTerm, setSearchTerm] = React.useState("");

  const [newDialogOpen, setNewDialogOpen] = React.useState(false);

  const [uploadDialogOpen, setUploadDialogOpen] = React.useState(false);

  const getParams = {
    bandobastId: props.bandobastId,
    page: pageNo,
    limit: rowsPerPage,
    search: searchTerm,
  };

  const extForcesQueryResponse = useGetExternalForcesQuery(getParams);

  const columns: GridColDef[] = [
    {
      field: "photo",
      headerName: strings.photo,
      width: 150,
      renderCell: (params: any) => (
        <img
          src={`${getBaseURL()}/bandobast/${
            props.bandobastId
          }/personnel/getPhoto/${params.row.id}`}
          height={100}
          alt={""}
        />
      ),
    },
    {
      field: "serialNo",
      headerName: strings.serialNo,
      width: 150,
    },
    {
      field: "name",
      headerName: strings.name,
      width: 200,
    },
    {
      field: "designationName",
      headerName: strings.designation,
      width: 300,
    },
    {
      field: "idNumber",
      headerName: strings.idNumber,
      width: 150,
    },
    {
      field: "mobileNumber",
      headerName: strings.mobileNumber,
      width: 150,
    },
  ];

  if (
    doesPermissionExist("update-personnel") ||
    doesPermissionExist("delete-personnel")
  ) {
    columns.push({
      field: "menu",
      headerName: "",
      width: 150,
      renderCell: (parameters: any) => {
        const options = [
          [
            null,
            <Stack direction={"column"} spacing={1}>
              {doesPermissionExist("update-personnel") && (
                <EditPersonnel
                  personnelId={parameters.id}
                  initialValues={parameters}
                />
              )}
              {doesPermissionExist("delete-personnel") && (
                <DeleteExternalForce
                  personnelId={parameters.id}
                  bandobastId={props.bandobastId!}
                />
              )}
            </Stack>,
            null,
            "locations",
            "action",
          ],
        ];
        return (
          <BasicMenu
            action={strings.actions}
            options={options}
            data={parameters.row}
            type="bandobast"
          />
        );
      },
    });
  }

  const handleChangePage = (event: any, value: any) => {
    setPageNo(value);
  };

  const handleChangeCount = (e: any) => {
    setRowsPerPage(e.target.value);
  };

  return (
    <div>
      <Box sx={{ height: 400, width: "100%" }}>
        <Grid container spacing={2}>
          {(extForcesQueryResponse.isLoading ||
            extForcesQueryResponse.isFetching) && <ProgressIndicator />}

          <Grid item xs={12}>
            <ButtonBar>
              {doesPermissionExist("create-personnel") && (
                <>
                  <NewButton
                    onClickHandler={() => {
                      setNewDialogOpen(true);
                    }}
                  />
                  <NewExternalForce
                    bandobastId={props.bandobastId!}
                    onSubmitHandler={(newObj: any) => {
                      setNewDialogOpen(false);
                    }}
                    onCancelHandler={() => {
                      setNewDialogOpen(false);
                    }}
                    state={newDialogOpen}
                  />
                  <UploadButton
                    onClickHandler={() => {
                      setUploadDialogOpen(true);
                    }}
                  />
                  <UploadExternalForces
                    bandobastId={props.bandobastId!}
                    state={uploadDialogOpen}
                    onSubmitHandler={(newObj: any) => {
                      setUploadDialogOpen(false);
                    }}
                    onCancelHandler={() => {
                      setUploadDialogOpen(false);
                    }}
                  />
                </>
              )}
              <SearchButton
                onClickHandler={(searchTerm: string) => {
                  setSearchTerm(searchTerm);
                }}
              />
            </ButtonBar>
          </Grid>
          <Grid item xs={10}></Grid>

          <Grid item xs={12}>
            <div>
              <CommonTable
                rows={
                  extForcesQueryResponse.data
                    ? extForcesQueryResponse.data?.data
                    : []
                }
                columns={columns}
                rowHeight={120}
              />
              <CommonPagination
                count={Math.ceil(
                  extForcesQueryResponse.data?.totalCount / rowsPerPage,
                )}
                page={pageNo}
                handleChangePage={handleChangePage}
                rowPerPage={rowsPerPage}
                handleChangeCount={handleChangeCount}
              />
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
